<mat-sidenav-container class="manage-email-sending-component">
  <mat-sidenav-content>
    <div class="ws-popup-header">
      <div class="manage-email-sending-title">
        {{ 'Manage email sending' | translate }}
      </div>
      <div class="actions">
        <button class="close-button" mat-icon-button (click)="cancelClicked()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="ws-popup-content">
      <div class="ws-popup-body">
        <mat-paginator hidden #paginatorTop [length]="dataSource.elementsSubject$ | async" showFirstLastButtons></mat-paginator>
        <div class="table-container">
          <table mat-table matSort matSortActive="typology" matSortDirection="asc" [dataSource]="dataSource" matSortDisableClear>
            <ng-container matColumnDef="typology" class="mat-column-typology">
              <th mat-header-cell *matHeaderCellDef class="align-left">
                {{ 'Typology' | translate }}
              </th>
              <td mat-cell *matCellDef="let manageEmailSending" class="align-left">
                <ng-container>
                  {{ manageEmailSending.type | translate }}
                  <ws-flag 
                    [countryCode]="extractLanguageFromType(manageEmailSending.type)" 
                    size="small" 
                    style="margin-left: 8px;">
                  </ws-flag>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="state" class="mat-column-state">
              <th mat-header-cell *matHeaderCellDef class="align-left">
                {{ "State" | translate }}
              </th>
              <td mat-cell *matCellDef="let manageEmailSending" class="align-left">
                {{ getState(manageEmailSending.sendAt, manageEmailSending.processedAt) | translate }}
              </td>
            </ng-container>

            <ng-container matColumnDef="date" class="mat-column-date">
              <th mat-header-cell *matHeaderCellDef class="align-left">
                {{ getDateHeader() }}
              </th>
              <td mat-cell *matCellDef="let manageEmailSending" class="align-left">
                {{ getDate(manageEmailSending.sendAt, manageEmailSending.processedAt, manageEmailSending.updatedAt) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions" class="mat-column-actions">
              <th mat-header-cell *matHeaderCellDef class="align-left">
                {{ 'Actions' | translate }}
              </th>
              <td mat-cell *matCellDef="let manageEmailSending" class="align-left">
                <ws-actions [options]="manageEmailSending.emailActions" (clickOnAction)="actionSelected($event)"
                  tooltip="{{ 'Select an action' | translate }}" icon="more_vertical">
                </ws-actions>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>
      <mat-paginator #paginatorBottom [length]="dataSource.elementsSubject$ | async" [pageSizeOptions]="[10, 20, 50]"
        [pageSize]="pageSize" showFirstLastButtons="false" (page)="handlePageBottom($event)">
      </mat-paginator>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>